import { FC } from "react";
import Script from "next/script";

interface Props {
  id: string;
  contentUrl?: string;
}

const OutBrain: FC<Props> = ({ id, contentUrl }) => {
  const getContentUrl = () => {
    if (contentUrl) {
      return contentUrl;
    }
    if (typeof window !== "undefined") {
      return window.location.href;
    }
    return "";
  };

  const handleScriptLoad = () => {
    console.log(`OutBrain script loaded successfully`);
    console.log(`OutBrain widget ${id} ready with URL: ${getContentUrl()}`);
  };

  const handleScriptError = (error: any) => {
    console.error(`OutBrain script failed to load:`, error);
  };

  return (
    <>
      <Script
        type="text/javascript"
        src="https://widgets.outbrain.com/outbrain.js"
        onLoad={handleScriptLoad}
        onError={handleScriptError}
      />
      <div
        className="OUTBRAIN"
        data-ob-contenturl={getContentUrl()}
        data-widget-id={id}
        data-ob-installation-key="TINDL20J008H0160OJOC02CF5"
      />
    </>
  );
};

export default OutBrain;
